// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dialog":"rC7mU","dialog-overlay":"BGTrQ"};